<template>
  <div>
    <div v-if="loading" class="d-flex justify-content-center bd-highlight mb-3">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div class="position-relative">
        <div class="text-dark font-size-18 font-weight-bold mb-1">
          Liquidação Pendente
        </div>
        <div class="text-gray-6 mb-2">
          Quanto será necessário liquidar no dia de hoje
        </div>
        <div class="font-weight-bold font-size-36 text-dark">
          {{ summary.current.amount | money }}
        </div>
        <vue-chartist
          class="height-200 ct-hidden-points"
          type="Line"
          :data="summary.graph"
          :options="options"
        />
      </div>

      <div class="mt-5 mb-2" :class="$style.textDivider">
        <h4
          class="font-size-20 font-weight-bold"
          :class="$style.textDividerContent"
        >
          Sumário de Liquidação
        </h4>
      </div>

      <a-form layout="vertical">
        <div class="row">
          <div class="col-md-4">
            <div class="ant-row ant-form-item">
              <div class="ant-col ant-form-item-control-wrapper">
                <div class="ant-form-item-control">
                  <span class="ant-form-item-children">
                    <a-select
                      v-model="filtrosLocal.date"
                      @change="handleDateChange"
                    >
                      <a-select-option :value="null">
                        Selecione
                      </a-select-option>
                      <a-select-option
                        :value="item.dtPayment"
                        v-for="(item, index) in dates"
                        :key="`data-${index}`"
                      >
                        {{ moment(item.dtPayment).format("DD/MM/YYYY") }} -
                        {{ item.amount | money }}
                      </a-select-option>
                    </a-select>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <b-button
              class="col-12"
              @click="getSummary"
              variant="primary"
              >Filtrar</b-button
            >
          </div>
          <div class="col-md-2">
            <b-button class="col-12" @click="limparFiltros">Limpar</b-button>
          </div>
        </div>
      </a-form>

      <b-table
        show-empty
        stacked="md"
        striped
        :borderless="true"
        :items="displayItens"
        :fields="fields"
      >
        <template v-slot:cell(dtPayment)="text">
          {{ moment(text.value).format("DD/MM/YYYY") }}</template
        >
        <template v-slot:cell(amount)="text">
          {{ text.value | money }}</template
        >
      </b-table>
    </div>
  </div>
</template>
<script>
import VueChartist from "v-chartist";
import ChartistTooltip from "chartist-plugin-tooltips-updated";
import moment from "moment";
import { PayoutLotResource } from "@/resources/PayoutLot.resource.js";
export default {
  name: "Prevision",
  components: {
    "vue-chartist": VueChartist,
  },
  data: function () {
    var formatter = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    });

    const options = {
      low: 0,
      chartPadding: {
        right: 0,
        left: 0,
        top: 5,
        bottom: 0,
      },
      fullWidth: true,
      showPoint: true,
      lineSmooth: false, //false,
      axisY: {
        showGrid: false,
        showLabel: false, //false,
        offset: 0,
      },
      axisX: {
        showGrid: true, //false,
        showLabel: false, //false,
        offset: 0,
      },
      showArea: true,
      plugins: [
        ChartistTooltip({
          anchorToPoint: false,
          appendToBody: true,
          seriesName: true,
          tooltipFnc: (_tooltipItems, data) => {
            return formatter.format(data);
          },
        }),
      ],
    };
    return {
      summary: {
        current: {},
        graph: {
          labels: [],
          series: [
            {
              className: "ct-series-d",
              data: [],
            },
          ],
        },
      },
      dates: [],
      loading: false,
      options,
      fields: [
        // { key: "idSaleChannel", label: "#" },
        { key: "dtPayment", label: "Data" },
        { key: "saleChannel", label: "Parceiro" },
        { key: "amount", label: "Valor" },
      ],
      itens: [],
      displayItens: [],
      filtrosLocal: {
        index: 1,
        size: 20,
        date: null,
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
    };
  },
  methods: {
    moment,
    getSummary() {
      this.loading = true;

      PayoutLotResource.getPayoutLotLiquidationSummary({})
        .then((result) => {
          try {

            var summaries = result.data.payload.dailySummaries.map(
              (x) => x.amount
            );
            var labels = result.data.payload.dailySummaries.map((x) =>
              moment(x.dtPayment)
            );
            this.dates = result.data.payload.dates;
            this.itens[this.filtrosLocal.index] =
              result.data.payload.saleChannelSummaries;
            this.displayItens = this.itens[this.filtrosLocal.index].flat();
            this.summary.current = result.data.payload.currentSummary;
            this.summary.graph.labels = labels;
            summaries.push(this.summary.current.amount);
            this.summary.graph.series = [
              {
                className: "ct-series-d",
                data: summaries,
              },
            ];
            this.loading = false;
          } catch (e) {
            throw {
              response: {
                data: {
                  failureReason: "Deu ruim na chamada...",
                },
              },
            };
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    handleDateChange(date) {},
    onChangePage(a) {
      this.filtrosLocal.index = a;
      this.getLista();
    },
    limparFiltros() {
      this.filtrosLocal = {
        index: 1,
        size: 50,
        date: null,
      };
      this.filtrar();
    },
  },
  mounted() {
    this.getSummary();
  },
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
